/**
 * External Dependencies
 */
import 'jquery';

import './tabs';

import 'slick-carousel';

import magnificPopup from 'magnific-popup';
// import './jquery.sticky'

function offsetBottom(el, i) {
  i = i || 0;
  return $(el)[i].getBoundingClientRect().bottom;
}

var $ = jQuery.noConflict();

$(document).ready(() => {
  var width_screen = $(window).width();

  if (width_screen > 768) {
    $('.vi-wpvs-variation-wrap-image .vi-wpvs-option-wrap')
      .mouseenter(function() {
        var variation_image_url = $(this)
          .find('.vi-wpvs-option-image')
          .attr('src');

        $(this).append(
          `<div class="vi-wpvs-option-image--tooltip"><img class="vi-wpvs-option-image--hover" src="${variation_image_url}"  /><span class="shadowArrow--down"></span></div>`
        );
      })
      .mouseleave(function() {
        $(this)
          .find('.vi-wpvs-option-image--tooltip')
          .remove();
      });
  }

  const $trigger = $(".woocommerce-Reviews-action");
  const $modal = $("#reviewModal");
  const $closeBtn = $(".review-modal-close");
  const $formWrapper = $("#review_form_wrapper");
  const $formCloneContainer = $("#review_form_wrapper_clone");

  function closeReviewModal() {
    if (!$modal.length) {
      return;
    }

    $modal.hide().attr("aria-hidden", "true");
    $("body").removeClass("review-modal-open");
  }

  function openReviewModal() {
    if (!$modal.length || !$formWrapper.length || !$formCloneContainer.length) {
      return;
    }

    $formWrapper.show();
    $formCloneContainer.empty().append($formWrapper);
    $modal.css("display", "flex").attr("aria-hidden", "false");
    $("body").addClass("review-modal-open");
  }

  if ($modal.length) {
    $modal.appendTo("body");
  }

  if ($trigger.length && $modal.length && $formWrapper.length && $formCloneContainer.length) {
    $trigger.on("click", function (e) {
      e.preventDefault();
      openReviewModal();
    });

    $closeBtn.on("click", closeReviewModal);

    $(document).on("click", ".review-cancel-btn", closeReviewModal);

    $(window).on("click", function (e) {
      if ($(e.target).is($modal)) {
        closeReviewModal();
      }
    });

    $(document).on("keyup", function (e) {
      if (e.key === "Escape" && $modal.is(":visible")) {
        closeReviewModal();
      }
    });
  }

    const ajaxUrl = (typeof wc_cart_fragments_params !== 'undefined' && wc_cart_fragments_params.ajax_url)
      ? wc_cart_fragments_params.ajax_url
      : (typeof danamAjax !== 'undefined' ? danamAjax.url : '/wp-admin/admin-ajax.php');

    let miniCartLoaded = false;
    const $cartPopup = $('#cartPopup');

    if ($cartPopup.length) {
      $cartPopup.appendTo('body');
    }

    function openCartPopup() {
      if (!$cartPopup.length) {
        return;
      }

      $cartPopup.addClass('is-open').fadeIn(200);
      $('body').addClass('cart-popup-open');
      loadMiniCart(false);
    }

    function closeCartPopup() {
      if (!$cartPopup.length) {
        return;
      }

      $cartPopup.removeClass('is-open').fadeOut(200);
      $('body').removeClass('cart-popup-open');
    }

    function updateCartBadge(count) {
      const $link = $('a.cart-link.cart-popup');
      if (!$link.length) {
        return;
      }

      const $badge = $link.find('.cart-link__count');
      if (count > 0) {
        if ($badge.length) {
          $badge.text(count);
        } else {
          $link.append('<span class="cart-link__count">' + count + '</span>');
        }
      } else {
        $badge.remove();
      }
    }

    function applyMiniCartHtml(html) {
      const $body = $('.cart-popup-content__body');
      if (!$body.length) {
        return;
      }

      $body.html(html);
      miniCartLoaded = true;
    }

    function loadMiniCart(forceReload) {
      const $body = $('.cart-popup-content__body');
      if (!$body.length) {
        return;
      }

      if (miniCartLoaded && !forceReload) {
        return;
      }

      if (forceReload) {
        miniCartLoaded = false;
      }

      $body.html('<p class="cart-popup-placeholder">Đang tải...</p>');

      $.post(ajaxUrl, { action: 'load_mini_cart' })
        .done(function(response) {
          if (response.success) {
            applyMiniCartHtml(response.data.html);
            if (typeof response.data.count !== 'undefined') {
              updateCartBadge(response.data.count);
            }
          } else {
            $body.html('<p class="cart-popup-placeholder">Không tải được giỏ hàng.</p>');
          }
        })
        .fail(function() {
          $body.html('<p class="cart-popup-placeholder">Không tải được giỏ hàng.</p>');
        });
    }

    $('.cart-popup').on('click', function(e) {
      e.preventDefault();
      openCartPopup();
    });
  
    $('.cart-popup-wrapper .cart-popup-overlay').on('click', function() {
      closeCartPopup();
    });

    $('.cart-popup-close').on('click', function() {
      closeCartPopup();
    });
  
    function applyBadgeClasses() {
      $('.wobd-text').each(function() {
        var text = $(this).text().trim().toLowerCase();
  
        if (text.includes("new") || text.includes("mới")) {
          $(this).parent().addClass("badge-red");
        }
  
        if (text.includes("best seller") || text.includes("bán chạy")) {
          $(this).parent().addClass("badge-yellow");
        }
      });
    }
  
    applyBadgeClasses();
  
    $(document).ajaxComplete(function() {
      applyBadgeClasses();
    });

    $(document).on('keyup', function(e) {
      if (e.key === 'Escape') {
        closeCartPopup();
      }
    });

    $(document.body).on('removed_from_cart', function(e, fragments) {
      miniCartLoaded = true;

      if (fragments && fragments['a.cart-link.cart-popup .cart-link__count'] !== undefined) {
        const $link = $('a.cart-link.cart-popup');
        $link.find('.cart-link__count').remove();
        if (fragments['a.cart-link.cart-popup .cart-link__count']) {
          $link.append(fragments['a.cart-link.cart-popup .cart-link__count']);
        }
      }
    });

    $(document).on('click', '.cart-popup-content__body .remove_from_cart_button', function(e) {
      if (typeof wc_add_to_cart_params !== 'undefined') {
        return;
      }

      e.preventDefault();

      const $btn = $(this);
      const cart_item_key = $btn.data('cart_item_key');
      const $item = $btn.closest('.cart-popup-item');

      $item.css('opacity', '0.5');

      $.post(ajaxUrl, {
        action: 'danam_remove_cart_item',
        cart_item_key: cart_item_key,
      })
        .done(function(response) {
          if (response.success) {
            if (response.data.html) {
              const $parsed = $(response.data.html);
              if ($parsed.hasClass('cart-popup-content__body')) {
                $parsed.replaceAll('.cart-popup-content__body');
              } else {
                applyMiniCartHtml(response.data.html);
              }
            } else {
              loadMiniCart(true);
            }

            if (typeof response.data.count !== 'undefined') {
              updateCartBadge(response.data.count);
            }

            $(document.body).trigger('wc_fragment_refresh');
          } else {
            $item.css('opacity', '1');
            alert('Không thể xóa sản phẩm khỏi giỏ hàng.');
          }
        })
        .fail(function() {
          $item.css('opacity', '1');
          alert('Không thể xóa sản phẩm khỏi giỏ hàng.');
        });
    });
    
    $('li[data-parent="0"]').each(function () {
      var $li = $(this);
      var $label = $li.find('.wpfFilterTaxNameWrapper');
      var count = $li.find('input[type="checkbox"]').attr('data-count') || ''; // backup nếu bạn dùng data-count riêng
      
      // Lấy số lượng sản phẩm từ text có sẵn (nếu plugin đã hiển thị)
      var text = $label.text().trim();
      var matched = text.match(/\((\d+)\)/);
  
      if (!matched) {
        // Nếu không có sẵn số lượng, bạn có thể đếm số mục con (optional)
        // var childCount = $li.find('ul li').length;
        // $label.text(text + ' (' + childCount + ')');
      }
    });
  
    // Ẩn số lượng sản phẩm ở các mục con
    $('li[data-parent!="0"] .wpfFilterTaxNameWrapper').each(function () {
      var text = $(this).text().trim();
      $(this).text(text.replace(/\s?\(\d+\)/, '')); // xóa (xxx)
    });
  
    function formatCurrency(num) {
      return num.toLocaleString('vi-VN') + ' đ';
    }
  
    function updateCartTotal() {
      let total = 0;
      $('.cart-popup-item').each(function () {
        const unitPrice = parseFloat($(this).find('.cart-popup-price').data('unit-price'));
        const qty = parseInt($(this).find('input').val());
        if (!isNaN(unitPrice) && !isNaN(qty)) {
          total += unitPrice * qty;
        }
      });
      $('.cart-popup-total strong').text(formatCurrency(total));
    }
  
    function updateCartItemQty(cart_item_key, quantity, $input, $priceContainer) {
      // update UI ngay
      $input.val(quantity);
      const unitPrice = parseFloat($priceContainer.data('unit-price'));
      if (!isNaN(unitPrice)) {
        const newSubtotal = unitPrice * quantity;
        $priceContainer.find('strong').text(formatCurrency(newSubtotal));
      }
      updateCartTotal();
  
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: {
          action: 'update_cart_item_quantity',
          cart_item_key: cart_item_key,
          quantity: quantity
        },
        success: function (response) {
          if (response.success) {
            loadMiniCart(true);
            $(document.body).trigger('wc_fragment_refresh');
          } else {
            alert('Không thể cập nhật giỏ hàng.');
          }
        }
      });
    }
  
    $(document).on('click', '.qty-plus, .qty-minus', function () {
      const $btn = $(this);
      const $input = $btn.siblings('input');
      const $item = $btn.closest('.cart-popup-item');
      const $price = $item.find('.cart-popup-price');
      const cart_item_key = $btn.data('key');
      let qty = parseInt($input.val());
  
      if ($btn.hasClass('qty-plus')) {
        qty += 1;
      } else if ($btn.hasClass('qty-minus') && qty > 1) {
        qty -= 1;
      }
  
      updateCartItemQty(cart_item_key, qty, $input, $price);
    });

    const breadcrumb = document.querySelector('.clink__breadcrumb');

    if (breadcrumb) {
        breadcrumb.innerHTML = breadcrumb.innerHTML.replace(/>Product</g, '>Sản phẩm<');
    }
    
    

  $('#collectionPage').skeletabs({
    breakpointLayout: 'destroy',
    breakpoint: 200,
    keyboardTabs: 'horizontal',
  });

  $('.menu-item-has-children > a').click(function(e) {
    e.preventDefault();
    $(this)
      .closest('.menu-item-has-children')
      .find('.sub-menu')
      .toggleClass('active');
    $(this)
      .closest('.menu-item-has-children')
      .toggleClass('active');
  });

  $('.openPopupBtn').magnificPopup({
    type: 'inline',
    preloader: false,
  });

  $('.collection-tab').click(function(e) {
    e.preventDefault();
    var $this = $(this);
    var $collection = $this.data('collection');
    $(this).addClass('active');
    $(this)
      .siblings()
      .removeClass('active');
    $('.collection-items').each(function() {
      $(this)
        .find('.collection-item')
        .hide();
    });
    $('.collection-item.' + $collection).each(function() {
      $(this).show();
    });
  });

  // related products
  if ($('.related.products .productItems').length > 0) {
    $('.related.products .productItems').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.related.products .arrow-left'),
      nextArrow: $('.related.products .arrow-right'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  }

  if ($('.home-partners__slider--desktop').length && width_screen > 767) {
    $('.home-partners__slider--desktop').slick({
      variableWidth: true,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      pauseOnHover: false,
    });
  }

  if (!$('body').hasClass('single-product')) {
    if ($('.gallery__items').length) {
      $('.gallery__items').slick({
        centerMode: true,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        prevArrow: $('.arrow-left'),
        nextArrow: $('.arrow-right'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '20px',
              slidesToShow: 1,
              adaptiveHeight: true,
              nextArrow: false,
              prevArrow: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              centerMode: true,
              autoplay: false,
              centerPadding: '0px',
              adaptiveHeight: true,
            },
          },
        ],
      });
    }

    $('.gallery').each(function() {
      const $this = $(this);

      if ($this.closest('.woo-variation-product-gallery, .woocommerce-product-gallery').length) {
        return;
      }

      $this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        prevArrow: $this.closest('.project-image').find('.slick-prev-item'),
        nextArrow: $this.closest('.project-image').find('.slick-next-item'),
        responsive: [
          {
            breakpoint: 768,
            settings: { slidesToShow: 1 },
          },
        ],
      });
    });
  }

  $('.image-wrappers').each(function() {
    const $this = $(this); 
    $this.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: `<div class="slick-prev"><svg version="1.1" id="fi_271220" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"><g><g>
		<path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
			C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
			c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
			l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      nextArrow: `<div class="slick-next"><svg version="1.1" id="fi_271228" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"><g><g>
		<path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
			c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
			c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
			c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>`,
      responsive: [
        {
          breakpoint: 991,
          settings: { slidesToShow: 5},
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 4},
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 3},
        },
      ],
    });
  });
  
  $(document).ready(function() {
    $('.mega-sub-menu').each(function() {
      var $menu = $(this);
      var $tabsColumn = $menu.find('.mega-menu-column').eq(0);
      var $tabs = $tabsColumn.find('.mega-menu-tab li');
      var $contentColumns = $menu.find('.mega-menu-column').slice(1);

      $contentColumns.hide();
      $contentColumns.eq(0).show();

      $tabs.removeClass('active');
      $tabs.eq(0).addClass('active');

      $tabs.each(function(index) {
        if($(this).hasClass('link')) {
          return;
        }
        
        $(this).on('click', function(e) {
          e.preventDefault();

          $tabs.removeClass('active');

          $(this).addClass('active');

          $contentColumns.hide();

          $contentColumns.eq(index).show();
        });
      });
    });
  });

  $('.timeline-slider').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.intro-content__path-top--arrow-left'),
    nextArrow: $('.intro-content__path-top--arrow-right'),
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  });

  $(document).on('click', '#projectSidebar a[href^="#"]', function(event) {
    event.preventDefault();

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top - 80,
      },
      1000
    );
  });

  jQuery(document).ready(function($) {
    var paged = 2;
    var loading = false;
    var selected = ''; // project_type hiện tại

    function loadMore() {
      if (loading) return;

      loading = true;
      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_projects',
          paged: paged,
          project_type: selected,
        },
        beforeSend: function() {
          $('#collectionProjects').append('<p class="loading">Đang tải...</p>');
        },
        success: function(response) {
          if (response.trim() != '') {
            $('#collectionProjects').append(response);
            paged++;
            loading = false;
          }
        },
        complete: function() {
          $('.loading').remove();
        },
      });
    }

    $('#tabsProjects li').on('click', function() {
      $('#tabsProjects li').removeClass('active');
      $(this).addClass('active');

      selected = $(this).data('slug');
      paged = 2; // reset về page 2
      loading = true;

      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_projects',
          paged: 1,
          project_type: selected,
        },
        beforeSend: function() {
          $('#collectionProjects').html('<p class="loading">Đang tải...</p>');
        },
        success: function(response) {
          $('#collectionProjects').html(response);
          loading = false;
        },
        complete: function() {
          $('.loading').remove();
        },
      });
    });
  });

  // if (width_screen > 768) {
  //
  //   $(document).on('click', function (e) {
  //     var searchForm = document.getElementsByClassName('dgwt-wcas-search-wrapp');
  //
  //     if (searchForm && !searchForm[0].contains(e.target)) {
  //       if ($('.dgwt-wcas-search-wrapp').hasClass('active')) {
  //         $('.dgwt-wcas-search-wrapp').removeClass('active')
  //       }
  //     }
  //   })
  //
  // }

  $(window).scroll(function() {
    if ($('.dgwt-wcas-search-wrapp').hasClass('active')) {
      $('.dgwt-wcas-search-wrapp').removeClass('active');
    }
  });

  $('.header__btnOpenSearch').click(function() {
    if (width_screen < 768) {
      $('.dgwt-wcas-overlay-mobile').slideToggle();
    }
    $('.dgwt-wcas-search-wrapp').toggleClass('active');
  });

  function getMobileNavMenus() {
    return $('.header__menu > ul, .header__menu .max-mega-menu, #menu-header-mobile-menu, #mega-menu-header_mobile');
  }

  function isMobileMenuView() {
    return $(window).width() <= 1240;
  }

  function setupMobileMegaMenuLinks() {
    var $links = $('#mega-menu-header_mobile > .mega-menu-item-has-children > .mega-menu-link');

    if (isMobileMenuView()) {
      $links.each(function() {
        if (!$(this).data('original-href')) {
          $(this).data('original-href', $(this).attr('href'));
        }
        $(this).attr('href', '#');
      });
      return;
    }

    $links.each(function() {
      var originalHref = $(this).data('original-href');
      if (originalHref) {
        $(this).attr('href', originalHref);
      }
    });
  }

  setupMobileMegaMenuLinks();
  $(window).on('resize', setupMobileMegaMenuLinks);

  $('.btnFilterAction--cancel').click(function(e) {
    e.preventDefault();

    var newUrl = refineUrl();

    window.history.pushState('object or string', 'Title', newUrl);

    return window.location.reload();
  });

  $('.btnFilterAction--apply').click(function(e) {
    e.preventDefault();
    $('body').removeClass('filtering');
    $('.productCategory__sidebar').removeClass('active');
  });

  $('.btnFilter').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('filtering');
    $('.productCategory__sidebar').toggleClass('active');
  });

  function closeMobileMenu() {
    $('body').removeClass('isFullScreen');
    $('.btnToggleMobileMenu').removeClass('active');
    getMobileNavMenus().removeClass('active');
  }

  $('.btnToggleMobileMenu').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('body').toggleClass('isFullScreen');
    $(this).toggleClass('active');
    getMobileNavMenus().toggleClass('active');
  });

  $(document).on('click', function(e) {
    if (
      $('body').hasClass('isFullScreen') &&
      !$(e.target).closest('.header__menu > ul, .header__menu .max-mega-menu, #menu-header-mobile-menu, #mega-menu-header_mobile, .btnToggleMobileMenu').length
    ) {
      closeMobileMenu();
    }
  });

  //dropdown mobile menu
  $(".header__menu .menu-item-has-children > a").click(function (e) {
    if (!isMobileMenuView()) {
      return;
    }

    e.preventDefault();

    var $clickedLi = $(this).parent();

    $clickedLi.siblings(".menu-item-has-children").removeClass("open").children(".sub-menu").slideUp(200);

    $clickedLi.toggleClass("open");
    $clickedLi.children(".sub-menu").slideToggle(200);
  });

  $(".header__menu #mega-menu-header_mobile > .mega-menu-item-has-children > .mega-menu-link").click(function (e) {
    if (!isMobileMenuView()) {
      return;
    }

    e.preventDefault();

    var $clickedLi = $(this).parent();

    $clickedLi.siblings(".mega-menu-item-has-children").removeClass("open").children(".mega-sub-menu").slideUp(200);

    $clickedLi.toggleClass("open");
    $clickedLi.children(".mega-sub-menu").slideToggle(200);
  });

  $('.woocommerce-filters-icon').click(function() {
    $('.productCategory__filters').toggleClass('active');
    if ($('.productCategory__filters').hasClass('active')) {
      $('.productCategory__wrapper').append('<div class="productCategory__sidebar--overlay"></div>');
    } else {
      $('.productCategory__sidebar--overlay').remove();
    }
  });

  $(document).on('click', '.productCategory__sidebar--overlay', function() {
    $(this).remove();
    $('.productCategory__filters').removeClass('active');
  });

  (function initShopAjaxFilters() {
    var $shop = $('[data-shop-archive]');
    var $products = $('[data-shop-products]');

    if (!$shop.length || !$products.length) {
      return;
    }

    var $filters = $('[data-shop-filters]');
    var $mobileFilters = $('[data-shop-mobile-filters]');
    var $description = $('[data-shop-category-description]');
    var childrenMap = $filters.data('childrenMap') || {};
    var $childrenNav = $filters.find('[data-shop-children]');
    var requestId = 0;
    var shopState = {
      currentPage: parseInt($products.data('currentPage'), 10) || 1,
      maxPages: parseInt($products.data('maxPages'), 10) || 1,
      hasMore: String($products.data('hasMore')) === '1',
      loadingMore: false,
    };
    var infiniteObserver = null;

    function syncShopPaginationState(data) {
      if (!data) {
        return;
      }

      if (typeof data.current_page !== 'undefined') {
        shopState.currentPage = parseInt(data.current_page, 10) || 1;
      }

      if (typeof data.max_pages !== 'undefined') {
        shopState.maxPages = parseInt(data.max_pages, 10) || 1;
      }

      if (typeof data.has_more !== 'undefined') {
        shopState.hasMore = !!data.has_more;
      }

      $products
        .attr('data-current-page', shopState.currentPage)
        .attr('data-max-pages', shopState.maxPages)
        .attr('data-has-more', shopState.hasMore ? '1' : '0');
    }

    function getActiveShopParams(overrides) {
      var params = paramsFromUrl(window.location.href);

      if (!params.term_id) {
        params.term_id = parseInt($shop.data('currentTermId'), 10) || 0;
      }

      $.extend(params, overrides || {});
      delete params.append;
      return params;
    }

    function sentinelIsNearViewport(node) {
      if (!node) {
        return false;
      }

      var rect = node.getBoundingClientRect();
      return rect.top <= window.innerHeight + 240;
    }

    function queueLoadMoreIfNeeded() {
      window.requestAnimationFrame(function() {
        if (!shopState.hasMore || shopState.loadingMore) {
          return;
        }

        var node = $products.find('[data-shop-infinite-sentinel]')[0];

        if (sentinelIsNearViewport(node)) {
          loadMoreShopProducts();
        }
      });
    }

    function ensureInfiniteSentinel() {
      var $sentinel = $products.find('[data-shop-infinite-sentinel]');

      if (!$sentinel.length) {
        $sentinel = $('<div class="shop-infinite-sentinel" data-shop-infinite-sentinel aria-hidden="true"></div>');
        $products.append($sentinel);
      }

      $sentinel.toggle(shopState.hasMore);
      observeInfiniteSentinel($sentinel.get(0));
    }

    function observeInfiniteSentinel(node) {
      if (!node) {
        return;
      }

      if ('IntersectionObserver' in window) {
        if (infiniteObserver) {
          infiniteObserver.disconnect();
        }

        infiniteObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              loadMoreShopProducts();
            }
          });
        }, {
          root: null,
          rootMargin: '240px 0px',
          threshold: 0,
        });

        if (shopState.hasMore) {
          infiniteObserver.observe(node);
        }

        return;
      }

      $(window).off('scroll.shopInfinite').on('scroll.shopInfinite', function() {
        if (!shopState.hasMore || shopState.loadingMore) {
          return;
        }

        var rect = node.getBoundingClientRect();
        if (rect.top <= window.innerHeight + 240) {
          loadMoreShopProducts();
        }
      });
    }

    function loadMoreShopProducts() {
      if (!shopState.hasMore || shopState.loadingMore) {
        return;
      }

      var params = getActiveShopParams();
      params.paged = shopState.currentPage + 1;
      params.append = 1;
      loadShopProducts(params, false, true);
    }

    function updateFilterUi(state) {
      if (!state) {
        return;
      }

      var activeParent = String(state.active_parent || 0);
      var activeChild = String(state.active_child || 0);
      var selectedIds = (state.selected_ids || []).map(String);

      $filters.find('.shop-filters__parent').each(function() {
        var $link = $(this);
        var parentId = String($link.data('parentId'));
        $link.toggleClass('is-active', parentId === activeParent && activeParent !== '0');
      });

      $filters.find('.shop-filters__parent[data-parent-id="0"]').toggleClass(
        'is-active',
        activeParent === '0' && activeChild === '0' && !selectedIds.length
      );

      if (activeParent !== '0' && childrenMap[activeParent]) {
        var html = '';
        childrenMap[activeParent].forEach(function(child) {
          var isActive = String(child.id) === activeChild ? ' is-active' : '';
          html +=
            '<a href="' +
            child.url +
            '" class="shop-filters__child' +
            isActive +
            '" data-child-id="' +
            child.id +
            '" data-term-id="' +
            child.id +
            '">' +
            child.name +
            '</a>';
        });
        $childrenNav.html(html).removeClass('is-hidden');
      } else {
        $childrenNav.addClass('is-hidden').empty();
      }

      $filters.find('.shop-filters__child').each(function() {
        var childId = String($(this).data('childId'));
        $(this).toggleClass('is-active', childId === activeChild);
      });

      $mobileFilters.find('input[name="shop_filter_cat"]').each(function() {
        var id = String($(this).val());
        $(this).prop('checked', selectedIds.indexOf(id) !== -1);
      });

      $shop.toggleClass('productCategory__wrapper--has-description', !!state.has_description);
    }

    function loadShopProducts(params, pushState, append) {
      var currentRequest = ++requestId;

      if (append) {
        shopState.loadingMore = true;
        $products.addClass('is-loading-more');
      } else {
        $shop.addClass('is-loading');
      }

      $.post(ajaxUrl, $.extend({ action: 'danam_load_shop_products' }, params))
        .done(function(response) {
          if (currentRequest !== requestId || !response || !response.success) {
            return;
          }

          if (append) {
            var itemsHtml = (response.data.items_html || '').trim();

            if (itemsHtml) {
              $products.find('ul.products').first().append(itemsHtml);
            } else if (response.data.has_more) {
              window.setTimeout(function() {
                loadMoreShopProducts();
              }, 0);
            }
          } else {
            $products.html(response.data.html);
            $description.html(response.data.description_html || '');
            updateFilterUi(
              $.extend({}, response.data.filter_state, {
                has_description: response.data.has_description,
              })
            );

            if (pushState && response.data.url) {
              window.history.pushState({ shopFilter: true }, '', response.data.url);
            }

            var top = $shop.offset().top - 20;
            if (window.pageYOffset > top) {
              $('html, body').animate({ scrollTop: top }, 250);
            }
          }

          syncShopPaginationState(response.data);
          ensureInfiniteSentinel();
          queueLoadMoreIfNeeded();
        })
        .fail(function() {
          if (!append && params.fallback_url) {
            window.location.href = params.fallback_url;
          }
        })
        .always(function() {
          if (currentRequest !== requestId) {
            return;
          }

          if (append) {
            shopState.loadingMore = false;
            $products.removeClass('is-loading-more');
          } else {
            $shop.removeClass('is-loading');
          }
        });
    }

    function resolveTermIdFromPath(pathname) {
      var termId = 0;

      $filters.find('.shop-filters__parent, .shop-filters__child').each(function() {
        if (termId) {
          return;
        }

        try {
          var linkPath = new URL($(this).attr('href'), window.location.origin).pathname;
          if (linkPath === pathname) {
            termId = parseInt($(this).data('termId') || $(this).data('childId') || 0, 10);
          }
        } catch (error) {
          return;
        }
      });

      return termId;
    }

    function paramsFromUrl(urlString) {
      var url = new URL(urlString, window.location.origin);
      var danamCats = url.searchParams.get('danam_cats');
      var orderby = url.searchParams.get('orderby') || '';
      var paged = url.searchParams.get('paged') || '1';
      var termId = danamCats ? 0 : resolveTermIdFromPath(url.pathname);

      return {
        term_id: termId,
        danam_cats: danamCats || '',
        orderby: orderby,
        paged: paged,
        fallback_url: url.href,
      };
    }

    function loadFromLink(href, overrides, pushState) {
      var params = paramsFromUrl(href);
      $.extend(params, overrides || {});
      params.paged = 1;
      loadShopProducts(params, pushState !== false);
    }

    $filters.on('click', '.shop-filters__parent', function(e) {
      var $link = $(this);
      var parentId = String($link.data('parentId'));
      var hasChildren = String($link.data('hasChildren')) === '1';

      if (parentId !== '0' && hasChildren && childrenMap[parentId]) {
        e.preventDefault();
        $filters.find('.shop-filters__parent').removeClass('is-active');
        $link.addClass('is-active');

        var html = '';
        childrenMap[parentId].forEach(function(child) {
          html +=
            '<a href="' +
            child.url +
            '" class="shop-filters__child" data-child-id="' +
            child.id +
            '" data-term-id="' +
            child.id +
            '">' +
            child.name +
            '</a>';
        });

        $childrenNav.html(html).removeClass('is-hidden');
        return;
      }

      e.preventDefault();
      loadFromLink($link.attr('href'), {
        term_id: parseInt($link.data('termId') || 0, 10),
        danam_cats: '',
      });
    });

    $filters.on('click', '.shop-filters__child', function(e) {
      e.preventDefault();
      var $link = $(this);
      loadFromLink($link.attr('href'), {
        term_id: parseInt($link.data('termId') || $link.data('childId') || 0, 10),
        danam_cats: '',
      });
    });

    $shop.on('change', '.woocommerce-ordering .orderby', function() {
      var params = paramsFromUrl(window.location.href);
      params.orderby = $(this).val();
      params.paged = 1;
      loadShopProducts(params, true);
    });

    if ($mobileFilters.length) {
      var $body = $('body');

      function openSheet(name) {
        var $sheet = $mobileFilters.find('[data-shop-sheet="' + name + '"]');

        if (!$sheet.length) {
          return;
        }

        $mobileFilters.find('.shop-sheet.is-open').not($sheet).removeClass('is-open').attr('hidden', true);
        $sheet.removeAttr('hidden');
        window.requestAnimationFrame(function() {
          $sheet.addClass('is-open');
        });
        $body.addClass('shop-sheet-open');
        $mobileFilters.find('[data-shop-sheet-open="' + name + '"]').attr('aria-expanded', 'true');
      }

      function closeSheets() {
        $mobileFilters.find('.shop-sheet.is-open').removeClass('is-open').attr('hidden', true);
        $body.removeClass('shop-sheet-open');
        $mobileFilters.find('[data-shop-sheet-open]').attr('aria-expanded', 'false');
      }

      $mobileFilters.on('click', '[data-shop-sheet-open]', function() {
        openSheet($(this).data('shopSheetOpen'));
      });

      $mobileFilters.on('click', '[data-shop-sheet-close]', function() {
        closeSheets();
      });

      $mobileFilters.on('change', 'input[name="shop_sort"]', function() {
        var params = paramsFromUrl(window.location.href);
        params.orderby = $(this).val();
        params.paged = 1;
        closeSheets();
        loadShopProducts(params, true);
      });

      $mobileFilters.on('click', '[data-shop-filter-reset]', function() {
        $mobileFilters.find('input[name="shop_filter_cat"]').prop('checked', false);
      });

      $mobileFilters.on('click', '[data-shop-filter-apply]', function() {
        var $checked = $mobileFilters.find('input[name="shop_filter_cat"]:checked');
        var params = paramsFromUrl(window.location.href);
        params.paged = 1;
        params.term_id = 0;

        if (!$checked.length) {
          params.danam_cats = '';
          closeSheets();
          loadShopProducts(params, true);
          return;
        }

        if ($checked.length === 1) {
          closeSheets();
          loadFromLink($checked.first().data('termUrl'), {
            term_id: parseInt($checked.first().val(), 10),
            danam_cats: '',
          });
          return;
        }

        params.danam_cats = $checked
          .map(function() {
            return $(this).val();
          })
          .get()
          .join(',');

        closeSheets();
        loadShopProducts(params, true);
      });

      $(document).on('keydown.shopMobileFilters', function(e) {
        if (e.key === 'Escape') {
          closeSheets();
        }
      });
    }

    window.addEventListener('popstate', function() {
      loadFromLink(window.location.href, {}, false);
    });

    ensureInfiniteSentinel();
  })();

  (function initProductMobileActions() {
    var $root = $('[data-product-mobile-actions]');

    if (!$root.length) {
      return;
    }

    var $body = $('body');

    function openSheet(name) {
      var $sheet = $root.find('[data-product-sheet="' + name + '"]');

      if (!$sheet.length) {
        return;
      }

      $root.find('.shop-sheet.is-open').not($sheet).removeClass('is-open').attr('hidden', true);
      $sheet.removeAttr('hidden');
      window.requestAnimationFrame(function() {
        $sheet.addClass('is-open');
      });
      $body.addClass('product-sheet-open');
      $root.find('[data-product-sheet-open="' + name + '"]').attr('aria-expanded', 'true');
    }

    function closeSheets() {
      $root.find('.shop-sheet.is-open').removeClass('is-open').attr('hidden', true);
      $body.removeClass('product-sheet-open');
      $root.find('[data-product-sheet-open]').attr('aria-expanded', 'false');
    }

    $root.on('click', '[data-product-sheet-open]', function() {
      openSheet($(this).data('productSheetOpen'));
    });

    $root.on('click', '[data-product-sheet-close]', function() {
      closeSheets();
    });

    $root.on('click', '[data-product-add-cart]', function() {
      var $cartBtn = $('.product-single .view_cart .single_add_to_cart_button').first();

      if ($cartBtn.length) {
        $cartBtn.trigger('click');
        return;
      }

      $('.product-single form.cart').first().trigger('submit');
    });

    $(document).on('keydown.productMobileActions', function(e) {
      if (e.key === 'Escape') {
        closeSheets();
      }
    });
  })();

  $('.smcw-cart-wrapper').appendTo('.cartHeader__wrapper');

  var $sticky = $('#productSummary');

  var total_gallery = $('.wc-tabs-wrapper .gallery').find('.gallery-item')
    .length;

  if (total_gallery > 6) {
    var ended_item = $('.wc-tabs-wrapper .gallery .gallery-item').eq(5);
    const remaining_items = ended_item.nextAll('.gallery-item').length;
    ended_item.nextAll('.gallery-item').hide();
    ended_item.addClass('last_item');
    ended_item
      .find('a')
      .append(`<span class="total">+${remaining_items}</span>`);
  }

  function danamConfigureProductGalleryThumbs() {
    $('.wpgs-thumb.slick-initialized').each(function () {
      const $thumb = $(this);
      const slideCount = $thumb.find('.slick-slide:not(.slick-cloned)').length;
      const isCarousel = slideCount > 3;
      const thumbOptions = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: isCarousel,
        infinite: isCarousel,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: isCarousel,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: isCarousel,
            },
          },
        ],
      };

      $thumb.toggleClass('wpgs-thumb--carousel', isCarousel);
      $thumb.slick('slickSetOption', thumbOptions, true);
    });
  }

  $(document).on('init', '.wpgs-thumb', function () {
    window.setTimeout(danamConfigureProductGalleryThumbs, 0);
  });

  $(document).on('found_variation', '.variations_form', function () {
    window.setTimeout(danamConfigureProductGalleryThumbs, 600);
  });

  // WVG thumbnail: cấu hình qua woo_variation_gallery_thumbnail_slider_js_options (setup.php).
  // Không gọi slickSetOption sau init — tránh giật layout (plugin 5 cột → JS ép 3 cột).

  $('.wpgs-no-gallery-images').each(function () {
    const $wrapper = $(this);
    const $main = $wrapper.find('.wpgs-image');

    $wrapper.find('.wpgs-thumb').remove();

    const disableGallerySlider = () => {
      if ($main.hasClass('slick-initialized')) {
        $main.slick('unslick');
      }
    };

    disableGallerySlider();
    setTimeout(disableGallerySlider, 500);
  });

  $('.wpgs-wrapper').each(function () {
    const $wrapper = $(this);
    const display = $('body').hasClass('single-product') ? 'flex' : 'block';

    $wrapper.css({ opacity: 1, display });
  });

  if ($('body').hasClass('single-product')) {
    const dedicatedVariationIds = new Set(
      ((window.danamProductGallery && window.danamProductGallery.dedicatedVariationIds) || []).map(Number)
    );

    function danamRevealProductGallery() {
      $('.woo-variation-gallery-wrapper').removeClass('loading-gallery');
    }

    // WVG init flow (variable product):
    // 1) constructor -> initSlick() on server HTML
    // 2) show_variation (default attrs) -> showVariationImage -> destroySlick + galleryInit + initSlick again
    // 3) woo_variation_gallery_image_loaded -> debounced initSlick (+500ms)
    // Steps 2–3 rebuild the same gallery and cause visible jitter — skip when variation has no dedicated WVG gallery.
    $(document).on('woo_variation_gallery_loaded', function (event, gallery) {
      const $form = gallery.$variations_form;

      if (!$form.length) {
        return;
      }

      $form.off('show_variation.wvg');
      $form.on('show_variation.wvg', function (e, variation) {
        if (!variation || !dedicatedVariationIds.has(Number(variation.variation_id))) {
          return;
        }

        gallery.showVariationImage(variation);
      });

      danamRevealProductGallery();
    });

    $(document).on('woo_variation_gallery_slider_slick_init', danamRevealProductGallery);
  }

  const $homePage = $('.home-page');

  if ($homePage.length) {
    const homeAnimateItems = [
      { selector: '.home-hero__content', classes: 'home-animate home-animate--left', immediate: true },
      { selector: '.home-hero__media', classes: 'home-animate home-animate--right', immediate: true, delay: 220 },
      { selector: '.home-partners .home-section-title', classes: 'home-animate' },
      { selector: '.home-partners__desc', classes: 'home-animate', delay: 120 },
      { selector: '.home-partners__slider-wrap', classes: 'home-animate home-animate--fade', delay: 240 },
      { selector: '.home-intro__content', classes: 'home-animate home-animate--left' },
      { selector: '.home-intro__gallery', classes: 'home-animate home-animate--right' },
      { selector: '.home-products .home-section-title', classes: 'home-animate' },
      { selector: '.home-products__tabs', classes: 'home-animate', delay: 120 },
      { selector: '.home-products__grid', classes: 'home-animate home-animate--stagger' },
      { selector: '.home-products__footer', classes: 'home-animate', delay: 300 },
      { selector: '.home-features__media', classes: 'home-animate home-animate--left' },
      { selector: '.home-features__content', classes: 'home-animate home-animate--right' },
      { selector: '.home-about .home-section-title', classes: 'home-animate' },
      { selector: '.home-about__content', classes: 'home-animate', delay: 150 },
    ];
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    homeAnimateItems.forEach(function(item) {
      $homePage.find(item.selector).each(function() {
        const $el = $(this);

        $el.addClass(item.classes);

        if (item.delay) {
          $el.attr('data-animate-delay', item.delay);
        }
      });
    });

    const $homeAnimated = $homePage.find('.home-animate');

    function revealHomeAnimated($elements) {
      $elements.each(function() {
        const $el = $(this);
        const delay = parseInt($el.attr('data-animate-delay'), 10) || 0;

        if (delay) {
          setTimeout(function() {
            $el.addClass('is-visible');
          }, delay);
          return;
        }

        $el.addClass('is-visible');
      });
    }

    window.revealHomeProductsGrid = function() {
      const $grid = $homePage.find('.home-products__grid');

      $grid.removeClass('is-visible');
      window.requestAnimationFrame(function() {
        $grid.addClass('is-visible');
      });
    };

    const $homeFooter = $homePage.find('.home-about .footer');

    function revealHomeFooter() {
      if (!$homeFooter.length) {
        return;
      }

      $homeFooter.addClass('is-circle-visible');

      setTimeout(function() {
        $homeFooter.addClass('is-content-visible');
      }, prefersReducedMotion ? 0 : 750);
    }

    if ($homeFooter.length) {
      $homeFooter.addClass('home-footer-reveal');
    }

    if (prefersReducedMotion) {
      revealHomeAnimated($homeAnimated);
      revealHomeFooter();
    } else {
      const $heroAnimated = $homePage.find('.home-hero .home-animate');
      const $scrollAnimated = $homeAnimated.not($heroAnimated);

      revealHomeAnimated($heroAnimated.filter('.home-hero__content'));
      setTimeout(function() {
        revealHomeAnimated($heroAnimated.filter('.home-hero__media'));
      }, 220);

      if ('IntersectionObserver' in window) {
        const homeAnimateObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) {
              return;
            }

            revealHomeAnimated($(entry.target));
            homeAnimateObserver.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -48px 0px',
        });

        $scrollAnimated.each(function() {
          homeAnimateObserver.observe(this);
        });

        if ($homeFooter.length) {
          const homeFooterObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting) {
                return;
              }

              revealHomeFooter();
              homeFooterObserver.unobserve(entry.target);
            });
          }, {
            threshold: 0.08,
            rootMargin: '0px 0px -80px 0px',
          });

          homeFooterObserver.observe($homeFooter[0]);
        }
      } else {
        revealHomeAnimated($scrollAnimated);
        revealHomeFooter();
      }
    }
  }

  const $homeProducts = $('.home-products');

  if ($homeProducts.length) {
    const $homeProductsGrid = $homeProducts.find('.home-products__grid');
    const $homeProductsFooter = $homeProducts.find('.home-products__footer');
    let homeProductsLoading = false;
    const featuredMobileMq = window.matchMedia('(max-width: 767px)');

    function getFeaturedProductsLimit() {
      return featuredMobileMq.matches ? 6 : 8;
    }

    function syncHomeProductsFooter(total) {
      if (total > getFeaturedProductsLimit()) {
        $homeProductsFooter.removeAttr('hidden');
      } else {
        $homeProductsFooter.attr('hidden', true);
      }
    }

    function trimHomeProductsGrid() {
      const limit = getFeaturedProductsLimit();

      $homeProductsGrid.find('.home-product-card').each(function(index) {
        $(this).toggle(index < limit);
      });
    }

    trimHomeProductsGrid();
    syncHomeProductsFooter(parseInt($homeProducts.data('total'), 10) || 0);

    featuredMobileMq.addEventListener('change', function() {
      trimHomeProductsGrid();
      syncHomeProductsFooter(parseInt($homeProducts.data('total'), 10) || 0);
    });

    $homeProducts.on('click', '.home-products__tab', function() {
      const $tab = $(this);
      const categoryId = $tab.data('category');

      if ($tab.hasClass('is-active') || homeProductsLoading) {
        return;
      }

      $homeProducts.find('.home-products__tab').removeClass('is-active');
      $tab.addClass('is-active');

      if (window.matchMedia('(max-width: 767px)').matches && $tab[0]) {
        $tab[0].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }

      homeProductsLoading = true;
      $homeProductsGrid.addClass('is-loading');

      $.post(ajaxUrl, {
        action: 'load_featured_products',
        category: categoryId,
        limit: getFeaturedProductsLimit(),
      }, function(response) {
        if (response.success) {
          const html = (response.data.html || '').trim();

          $homeProductsGrid.html(
            html !== ''
              ? html
              : '<p class="home-products__empty">Chưa có sản phẩm trong danh mục này.</p>'
          );

          if (typeof response.data.total !== 'undefined') {
            $homeProducts.data('total', response.data.total);
          }

          syncHomeProductsFooter(
            typeof response.data.total !== 'undefined'
              ? parseInt(response.data.total, 10)
              : parseInt($homeProducts.data('total'), 10) || 0
          );

          if (typeof window.revealHomeProductsGrid === 'function') {
            window.revealHomeProductsGrid();
          }
        }
      }).always(function() {
        homeProductsLoading = false;
        $homeProductsGrid.removeClass('is-loading');
        applyBadgeClasses();
      });
    });
  }

  const $reviewsGrid = $('.reviews-page__grid');

  if ($reviewsGrid.length) {
    let reviewsPage = parseInt($reviewsGrid.data('page'), 10) + 1;
    let reviewsLoading = false;
    let reviewsHasMore = String($reviewsGrid.data('has-more')) === '1';
    const $reviewsLoader = $('.reviews-page__loading');

    function loadMoreReviews() {
      if (reviewsLoading || !reviewsHasMore) {
        return;
      }

      reviewsLoading = true;
      $reviewsLoader.removeAttr('hidden');

      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_customer_reviews',
          page: reviewsPage,
        },
        success: function(response) {
          if (response.trim() !== '') {
            const $newCards = $(response.trim());

            $reviewsGrid.append($newCards);

            const total = parseInt($reviewsGrid.data('total'), 10);
            const loaded = $reviewsGrid.find('.reviews-page__card').length;

            if (loaded >= total) {
              reviewsHasMore = false;
              $reviewsGrid.attr('data-has-more', '0');
              $reviewsLoader.remove();
            } else {
              reviewsPage++;
            }
          } else {
            reviewsHasMore = false;
            $reviewsGrid.attr('data-has-more', '0');
            $reviewsLoader.remove();
          }
        },
        complete: function() {
          reviewsLoading = false;
          $reviewsLoader.attr('hidden', true);
        },
      });
    }

    $(window).on('scroll.reviewsPage', function() {
      if (!reviewsHasMore || reviewsLoading) {
        return;
      }

      const gridBottom = $reviewsGrid.offset().top + $reviewsGrid.outerHeight();
      const scrollBottom = $(window).scrollTop() + $(window).height();

      if (scrollBottom >= gridBottom - 300) {
        loadMoreReviews();
      }
    });
  }
});

function refineUrl() {
  //get full url
  var url = window.location.href;
  //get url after/
  var value = (url = url.slice(0, url.indexOf('?')));
  //get the part after before ?
  value = value.replace(
    '@System.Web.Configuration.WebConfigurationManager.AppSettings["BaseURL"]',
    ''
  );
  return value;
}
